import carryOverIdentificator from 'src/internal/carryOverIdentificator';

export const ALLOWED_PARAM_CHARS = /[^!?]+/g;

const PARAM_REGEX = new RegExp(`:(${ALLOWED_PARAM_CHARS.source})`);
const SINGLE_CARRY_OVER_PARAM_REGEX = new RegExp(`${PARAM_REGEX.source}!`, 'g');

export default function addCarryOverIdentifiers(path: string): string {
  return path.replace(
    SINGLE_CARRY_OVER_PARAM_REGEX,
    `:${carryOverIdentificator}$1?`,
  );
}
